/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from '@exo/frontend-common-i18n';
import { gql } from '@apollo/client';
import { LoadingIndicator, RadioButton } from '@exo/frontend-components-base';
import { LayoutSpacing } from '@exo/frontend-components-core';
import {
  PaymentMethodsContainer,
  PaymentMethodsContainerRenderProps,
  useCheckoutContext
} from '@exo/frontend-features-checkout-logic';
import { NoopPayment, PaymentHandle } from '@exo/frontend-features-payments-logic';
import { AccountPayment } from '@exo/frontend-features-payments-provider-account';
//import { StripePayment } from '@exo/frontend-features-payments-provider-stripe';
import { isCardPayment, isOfflinePayment } from '../../utils/paymentUtils';
import * as S from './PaymentPanel.styles';
import { PaymentButtons } from './PaymentButtons/PaymentButtons';
import { GlobalPayment } from '@exo/frontend-features-payments-provider-global-payments';
import { Cart, CartContainer, useCart } from '@exo/frontend-features-cart-logic';
import { CheckoutSidebar } from '../../components/CheckoutSidebar/CheckoutSidebar';
import { useSessionContext } from '@exo/frontend-common-session-context';
import { useScrollViewportTo } from '@exo/frontend-common-hooks';


//clubhire golbal variables
export type bookingDetailsType = {
  idsPiped: string | undefined;
};

let refPresent: boolean = false;
let bookingDetails = {} as bookingDetailsType;

const PaymentMethods = ({ availablePaymentMethods }: PaymentMethodsContainerRenderProps) => {
  const [state, setState] = useState('valid');
  const ref = useRef<PaymentHandle>(null);
  const intl = useIntl('features.checkout.checkout-ui.panels.Paymentpanel');
  const { checkout, dispatch } = useCheckoutContext();
  const [selectedPaymentOption, setSelectedPaymentOption] = useState<string>();
  const [pageLoading, setPageLoading] = useState<boolean>(true);
  const session = useSessionContext();

  useScrollViewportTo(0, 0);

  // ClubHire begins here
  let cartId = checkout.context.cartId;

  const clubHireBookingID = session?.clubHireBookingID;

  if (clubHireBookingID) {
    bookingDetails = {
      "idsPiped": (clubHireBookingID)?.toString()
    }
  }

  const {
    data: cartData,
    loading: cartLoading,
    error: cartError
  } = useCart<Cart>(
    { cartId },
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    PaymentPanel.fragment2
  );
  const grandTotalValueFromCart = cartData?.me?.carts[0]?.grandTotal.value.toString();
  const isTotalPriceNaN = typeof grandTotalValueFromCart !== 'undefined' ? isNaN(parseInt(grandTotalValueFromCart)) : true;

  const priceFinalCheck = typeof grandTotalValueFromCart !== 'undefined' ? parseInt(grandTotalValueFromCart) === 0 : false;
  // console.log('chk+++++++++++++++++++++',priceFinalCheck)
  const getAvailablePaymentMethods = () => {
    return priceFinalCheck && !isTotalPriceNaN
      ? [{ ...availablePaymentMethods.find(p => p.id === 'VOUCHER'), selected: true }]
      : [{ ...availablePaymentMethods.find(p => p.id === 'CREDIT_CARD') }];
  };
  useEffect(() => {
    if (!cartLoading && cartData) {
      let lineItems = cartData?.me?.carts[0]!.lineItems;
      // let count = 0;
      lineItems.map(item => {
        if (item.custom?.fields?.BookingReference !== undefined && !refPresent) {
          refPresent = true;
        }
      });
      setPageLoading(false);
      // if (refPresent === false) {
      //   refPresent = true;
      //   setPageLoading(false);
      // }
    }
    else if (!cartLoading && cartError) {
      refPresent = true;
      setPageLoading(false);
    }
  }, [cartLoading]);
  // Clubhire Ends here


  useEffect(() => {
    //setSelectedPaymentOption(availablePaymentMethods[0].id);
    priceFinalCheck && setSelectedPaymentOption('VOUCHER');
  }, [availablePaymentMethods]);

  const processAndConfirm = async (attributes: { name: string; value: string }[] = []) => {
    dispatch({ type: 'NEXT', paymentMethod: selectedPaymentOption, attributes });
    sessionStorage.setItem("GoogleAnalyticsPushed", "false");
  };

  const radioCheck = pm => {
    if (selectedPaymentOption === pm.id || pm?.selected) {
      const dp =
        (document?.getElementById('redeemCode')?.children! as HTMLCollectionOf<HTMLElement>) || [];
      if (dp.length) {
        dp[0].style.pointerEvents = 'none';
      }
      const promoApplyBtn = document?.getElementById('promocode-wrapper')?.children[0]!;
      if (promoApplyBtn) {
        promoApplyBtn?.children[1]?.setAttribute('disabled', 'disabled');
      }

      document?.getElementById('promocode-inputs')?.setAttribute('disabled', 'disabled')!;
      document?.getElementById('giftSelect')?.setAttribute('disabled', 'disabled')!;
      document?.getElementById('GCNum')?.setAttribute('disabled', 'disabled')!;
      document?.getElementById('Acode')?.setAttribute('disabled', 'disabled')!;
      document?.getElementById('reedemCodeButton')?.setAttribute('disabled', 'disabled')!;
      document?.getElementsByClassName('reedemBtn')[0]?.setAttribute('disabled', 'disabled')!;
    }
  };

  const shippingheader = checkout.context.shippingAddress ? 'Shipping Address' : '';

  const {
    data: cartInfo
  } = useCart<any>({ cartId: session.cartId! }, CartContainer.fragment);
  let d = cartInfo?.me?.carts[0]!;
  return pageLoading ? (
    <LoadingIndicator />
  ) : (
    <>
      {/*removed as it is not needed -- bug 6808*/}
      {/*<S.PaymentHeader>{'Delivery Type'}</S.PaymentHeader>*/}
      <LayoutSpacing size="sm" />
      {checkout.context.loading && <LoadingIndicator />}
      {/*changed to Shipping Address for bug6808*/}
      <CartContainer
        render={args => (
          <>
            {
              <S.PaymentHeader>
                {shippingheader ? intl.msg('paymentpanel.payment', 'Shipping Address') : ''}
              </S.PaymentHeader>
            }
            <CheckoutSidebar
              {...d}
              shippingAddress={checkout.context.shippingAddress}
              addressShow={true}
            />
            <S.SplitAdd>
              {checkout.context.useBillingAddress && (
                <>
                  <S.PaymentHeader>
                    {intl.msg('paymentpanel.payment', 'Billing Address')}
                  </S.PaymentHeader>
                  <CheckoutSidebar
                    {...d}
                    billingAddress={checkout.context.billingAddress}
                    addressShow={true}
                  />
                </>
              )}
            </S.SplitAdd>
          </>
        )}
      />
      <LayoutSpacing size="sm" />
      <S.PaymentHeader>{intl.msg('paymentpanel.payment', 'Mode of Payment')}</S.PaymentHeader>

      <LayoutSpacing size="sm" />
      {isTotalPriceNaN && (<>
        <h2>There was a problem by recovering the cart details. Please try again later</h2>
      </>)}
      {!isTotalPriceNaN && getAvailablePaymentMethods().map(pm => (
        <React.Fragment key={pm.id}>
          <S.PaymentMethodHeader
            onClick={() => setSelectedPaymentOption(pm.id)}
            selected={selectedPaymentOption === pm.id || pm?.selected}
          >
            <RadioButton id={`pm_${pm.id}`} name="payment-method" />
            <S.PaymentName htmlFor={`pm_${pm.id}`}>{pm.description}</S.PaymentName>
          </S.PaymentMethodHeader>
        </React.Fragment>
      ))}

      {!isTotalPriceNaN && availablePaymentMethods.map(pm => (
        <>
          {selectedPaymentOption === pm.id && (
            <S.Widget>
              {priceFinalCheck && isOfflinePayment(selectedPaymentOption) && (
                <NoopPayment ref={ref}>
                  {intl.msg(
                    'paymentpanel.note',
                    'This payment does not require any additional input'
                  )}
                </NoopPayment>
              )}

              {isCardPayment(selectedPaymentOption) && (
                <GlobalPayment
                  cartId={checkout.context.cartId}
                  ref={ref}
                  billingAddress={checkout.context.billingAddress ?? {}}
                  shippingAddressEmail={
                    (checkout.context.shippingAddress?.email ||
                      checkout.context.billingAddress?.email) ??
                    {}
                  }
                  processAndConfirm={processAndConfirm}
                  bookingDetails = {bookingDetails}
                  totalCartAmount = {!isTotalPriceNaN ? grandTotalValueFromCart : 0.00}
                />
              )}
              {selectedPaymentOption === 'account-payment' && <AccountPayment ref={ref} />}
            </S.Widget>
          )}
        </>
      ))}
      {!isTotalPriceNaN && priceFinalCheck && !isCardPayment(selectedPaymentOption) && (
        <PaymentButtons
          nextText={intl.msg('button.nexttext', 'Confirm and Pay') as string}
          prevText={intl.msg('button.prevtext', 'Back') as string}
          isNextDisabled={state !== 'valid'}
          onPrev={() => dispatch({ type: 'PREVIOUS' })}
          onNext={async () => {
            setState('loading');
            try {
              const attributes = await ref.current?.submit();
              setState('valid');
              if (attributes !== undefined) {
                processAndConfirm(attributes);
              }
            } finally {
              setState('valid');
            }
          }}
        />
      )}
    </>
  );
};


export const PaymentPanel = () => {
  const { checkout } = useCheckoutContext();

  return (
    <PaymentMethodsContainer
      data-testid="payment-methods"
      cartId={checkout.context.cartId}
      renderLoading={() => <LoadingIndicator />}
      render={({ availablePaymentMethods }) => {
        return <PaymentMethods availablePaymentMethods={availablePaymentMethods} />;
      }}
    />
  );
};

PaymentPanel.fragment = gql`
  fragment PaymentMethods on CrtCart {
    id
    availablePaymentMethods {
      id
      identifier
      description
      type
    }
  }
`;

PaymentPanel.fragment2 = gql`
  fragment Cart on CrtCart {
    id
    grandTotal {
      currency
      value
    }
    lineItems {
      id
      quantity
      partnumber
      custom {
        fields {
          BookingReference
        }
      }
      unitPrice {
        currency
        value
      }
    }
  }
`;
